import { Input } from '@/components/ui/input';
import { TProductWithRelation } from '@/types/product-type';
import { Search } from 'lucide-react';

interface ProductFilterBarProps {
  productsWithRelations: TProductWithRelation[];
  selectedProductId: string | null;
  onProductChange: (productId: string | null) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export function ProductFilterBar({ searchQuery, onSearchChange }: ProductFilterBarProps) {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Prevent form submission when Enter is pressed in search input
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 mt-3">
      <div className="relative flex-1 sm:max-w-sm">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search products or variants..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          onKeyDown={handleKeyDown}
          className="pl-9"
        />
      </div>
    </div>
  );
}
